var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"changeFitout"},_vm._l((_vm.fitouts),function(fitout,fitName){return _c('li',{key:fitName,on:{"click":function($event){return _vm.changeFitout(fitout.name)}}},[_c('AtomsCommonAtomButton',{attrs:{"label":fitout.buttonText}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }